import { useTranslation } from "react-i18next";
import { LeftSocialMediaIconUI } from "../../components/LeftSocialMediaIconUI";
import { KMCDepartmentLeftManu } from "../../components/KMCDepartmentLeftManu";

const Basic_Statistic = () => {
  const { t } = useTranslation();

  return (
    <>
      <>
        {/* Slider */}
        <section id="hero" className="hero hero2">
          <LeftSocialMediaIconUI />

          <div className="carousel-item active">
            <img
              src="assets/img/inner-bg2.png"
              className="img-fluid"
              alt="alt"
            />
            <div className="container">
              <div className="section-main-heading2">
                <h4 className="fontSizeClass">
                  {t("About Us - Basic Statistics")}
                </h4>
              </div>
            </div>
          </div>
        </section>
        {/* End Slider */}

        <section className="section inner-pad1">
          <div className="container">
            <div className="row">
              <div className="col-lg-3">
                <div className="site-menu  min-height-400">
                  <KMCDepartmentLeftManu />
                </div>
              </div>
              <div className="col-lg-9">
                <div className="container">
                  <div className="row">
                    <div className="inner-title">
                      <h3 className="fontSizeClass">{t("Basic Statistics")}</h3>
                    </div>
                    <div className="mayor-table">
                      <table className="table table-bordered basic_static_table">
                        <thead>
                          <tr className="table-warning table-bor-2">
                            <th colSpan={2} scope="col">
                              {t("Basic Statistics")}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {[
                            {
                              name: "Geographical Location",
                              desc: "Kolkata, located at 22°30´ North latitude, 88°30´ East longitude, is the main port entry in North Eastern India. It is 120 kmfrom the Bay of Bengal and stands on the eastern bank of river Hooghly (Ganga)",
                            },
                            {
                              name: "Area",
                              desc: "206.08 sq km",
                            },
                            {
                              name: "Climate",
                              desc: "Humid during summer and pleasant in winter",
                            },
                            {
                              name: "Maximum Temperature",
                              desc: "40°C",
                            },
                            {
                              name: "Minimum Temperature",
                              desc: "10°C",
                            },
                            {
                              name: "Average Rainfall",
                              desc: "1400-1600 mm per year",
                            },
                            {
                              name: "Population",
                              desc: "more than 4.5 million",
                            },
                            {
                              name: "Density",
                              desc: "24,252 per sq. km.",
                            },
                            {
                              name: "Buildings",
                              desc: "1 million, out of which 79.23% are reinforced, cement concrete structures",
                            },
                            {
                              name: "Language",
                              desc: "Majority of the citizens speak Bengali",
                            },
                            {
                              name: "Official Language",
                              desc: "Bengali",
                            },
                            {
                              name: "Business Language",
                              desc: "English",
                            },
                            {
                              name: "Vehicular Population",
                              desc: "1.05 million",
                            },
                            {
                              name: "Total Road Length",
                              desc: "4636 km(main throughfare 1850 km)",
                            },
                            {
                              name: "No. of Boroughs",
                              desc: "16",
                            },
                            {
                              name: "No. of Wards",
                              desc: "144",
                            },
                            {
                              name: "No. of Employees of KMC",
                              desc: "20463 (as on 01.04.2019)",
                            },
                            {
                              name: "Total Length of Sewer Lines",
                              desc: "brick sewer length 200 km piped sewer length about 1784 km",
                            },
                            {
                              name: "Total Length of Open Drains",
                              desc: "953 km",
                            },
                            {
                              name: "Water Supply",
                              desc: "437 MGD",
                            },
                            {
                              name: "Hand Tube-wells",
                              desc: "12,000",
                            },
                            {
                              name: "Large Tube-wells",
                              desc: "350",
                            },
                            {
                              name: "Solid Waste Generation and Disposal per day",
                              desc: "4,500 MT per day",
                            },
                            {
                              name: "Primary Schools under KMC",
                              desc: "256",
                            },
                            {
                              name: "No. of KMC Parks",
                              desc: "700",
                            },
                            {
                              name: "No. of immersion ghats(River front)",
                              desc: "17",
                            },
                            {
                              name: "No. of Electric Crematoria",
                              desc: "8",
                            },
                            {
                              name: "No. of Crematoria",
                              desc: "8",
                            },
                            {
                              name: "No. of Burial Ghats",
                              desc: "7(KMC managed)",
                            },
                            {
                              name: "No. of KMC Registered Markets",
                              desc: "47",
                            },
                          ].map((item, index) => (
                            <tr key={index}>
                              <th scope="row"> {t(item.name)} :</th>
                              <td>{t(item.desc)}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
    </>
  );
};

export default Basic_Statistic;
